import { useLanguage } from "../context/LanguageContext";
import { Reveal } from "./Reveal";

export const BuyWithConfidence = () => {
  const { t } = useLanguage();

  return (
    <div id="comprar" data-testid="buy-section">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal>
          <p className="mb-5 font-mono text-[11px] uppercase tracking-[0.35em] text-gold" data-testid="buy-eyebrow">
            {t.buy.eyebrow}
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="max-w-3xl font-display text-2xl font-normal leading-snug tracking-tight text-sand sm:text-3xl lg:text-4xl" data-testid="buy-title">
            {t.buy.title}
          </h2>
        </Reveal>
        <div className="mt-10 grid gap-8 lg:grid-cols-2 lg:gap-16">
          <Reveal delay={0.15}>
            <p className="font-display text-lg italic leading-relaxed text-sand/90 sm:text-xl" data-testid="buy-lead">
              {t.buy.p1}
            </p>
          </Reveal>
          <Reveal delay={0.22}>
            <p className="text-sm leading-relaxed text-mist sm:text-base">{t.buy.p2}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-px overflow-hidden rounded-xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-3" data-testid="buy-items">
          {t.buy.items.map((item, i) => (
            <Reveal key={item.n} delay={0.06 + i * 0.06} y={24} className="h-full">
              <div
                className="group flex h-full flex-col bg-basalt p-8 transition-colors duration-500 hover:bg-surface"
                data-testid={`buy-item-${item.n}`}
              >
                <span className="font-mono text-sm text-terracotta transition-transform duration-500 group-hover:-translate-y-1">
                  {item.n}
                </span>
                <h3 className="mt-14 font-display text-xl text-sand sm:text-2xl">{item.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-mist">{item.desc}</p>
                <span className="mt-auto block pt-8">
                  <span className="block h-px w-8 bg-white/20 transition-all duration-500 group-hover:w-full group-hover:bg-terracotta" />
                </span>
              </div>
            </Reveal>
          ))}
          <Reveal delay={0.36} y={24} className="hidden h-full sm:block">
            <div className="flex h-full items-center justify-center bg-basalt p-8">
              <img src="/logo.svg" alt="" aria-hidden="true" className="w-40 opacity-[0.12]" />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  );
};
